import { useEffect } from 'react';

// refs array length must never change
export default function useClickOutside(handler, refs) {
  useEffect(() => {
    function onClick(e) {
      const clickOutside = refs.every(({ current }) => !current || !current.contains(e.target));
      if (clickOutside) {
        handler(e);
      }
    }
    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
    };
  }, [handler, ...refs]);
}
